<template>
  <div class="hiring-process-container">
    <Step
      v-for="step in module.modules"
      :key="step.id"
      :id="step.id"
      :module="step"
      :parentModule="module"
    />
  </div>
</template>

<script>
import hiringProcessModule from "../hiringProcessDefaultModuleProp.js";
import {
  globalComputed,
  globalMethods,
} from "../../../GlobalUI/mixins/global.js";
import Step from "../../Step/Step.vue";

export default {
  name: "HiringProcessVertical",
  components: {
    Step,
  },
  mixins: [globalComputed, globalMethods],
  props: {
    module: {
      type: Object,
      default() {
        return hiringProcessModule;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@include reset;

.hiring-process-container {
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-inline: 128px;

  @include laptop {
    margin-inline: 64px;
  }

  @include mobile {
    margin-inline: 25px;
  }
}
</style>
